<template>
<div class="tab-inner-content">
    <div class="tabs-content-panel pad20">
        <div class="card-panels pt-0">
            <vs-row vs-justify="center" v-if="checkCurrentUrl && false ">
                <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <div class="pd_upload_actions pd_upload_actions_right" @click="parentId ='';formerrors.msg=''" >
                        <div class="doc_header pt-0 d pb-0" >
                             <div class="d-flex">   

                                 <button v-if="checkCurrentUrl && false " @click="downloadallfile()"   class="download_all">Case Documents</button>
                    
                             </div>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
            <!-- <NoDataFound ref="NoDataFoundRef"  v-if="formsAndLettersList.length == 0" content="" heading="No Documents Found." type='documents' /> -->
            <!-- :formsAndLettersList="formsAndLettersList" -->
            <template  >
                <vs-row vs-justify="center"  >
                <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <div class="forms_letters dd forms_letters-v2"> 

                        <vs-card class="no-card  FL-height">
                                    <scannedView @pet_view_and_sign="pet_view_and_sign" :workFlowDetails="workFlowDetails" :eFileTagsList="eFileTagsList" :tabName="'Scanned Documents'" @dcoumentDelete="dcoumentDelete" v-if="(( [2,10,11].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1 &&  checkProperty(petition,'petitionerId') ) || [2,10,11].indexOf(checkProperty(petition,'typeDetails', 'id'))<=-1  ) && ([51].indexOf(getUserRoleId)<=-1 || IsSponsorLogin) && ( getUserRoleId !=50 || ( (getUserRoleId ==50 || IsSponsorLogin) && petition['completedActivities'].indexOf('REQUEST_PETITIONER_SIGN') >-1 ) )" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Petitioner'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Petitioner'" ref="PetitionerSign" />
                                        <template v-if="( [2,10,11].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1    ) ||  (checkProperty(petition,'beneficiaryInfo','maritalStatus' ) !=1 &&   ((!isL1Case && checkProperty(petition['dependentsInfo']['spouse'], 'h4Required')==true || checkIsChildh4Required ) || (isL1Case &&checkProperty(petition['dependentsInfo']['spouse'], 'l2Required')==true || checkIsChildh4Required ) ))">
                                         <scannedView @pet_view_and_sign="pet_view_and_sign" :workFlowDetails="workFlowDetails" :eFileTagsList="eFileTagsList" :tabName="'Scanned Documents'" @dcoumentDelete="dcoumentDelete" v-if="[50].indexOf(getUserRoleId)<=-1 && ( getUserRoleId !=51 || ( getUserRoleId ==51 && petition['completedActivities'].indexOf('REQUEST_BENEFICIARY_SIGN') >-1 ) )" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Beneficiary'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Beneficiary'"/>
                                        </template>
                                    <scannedView :workFlowDetails="workFlowDetails" :eFileTagsList="eFileTagsList" :tabName="'Scanned Documents'" @dcoumentDelete="dcoumentDelete" v-if="[51,50].indexOf(getUserRoleId)<=-1" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Internal'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Internal'"  ref="InternalSection" />
                                </vs-card>
                        <vs-tabs v-if="false">
                            <vs-tab :label="'Recent'" >
                                <vs-card class="no-card  FL-height">
                                    <scannedView v-if="(( [2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1 &&  checkProperty(petition,'petitionerId') ) || [2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))<=-1  ) && [51].indexOf(getUserRoleId)<=-1" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Petitioner'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Petitioner'" />
                                   
                                    <template v-if="[2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1 || (checkProperty(petition,'beneficiaryInfo','maritalStatus' ) !=1 &&   checkProperty(petition['dependentsInfo']['spouse'], 'h4Required')==true)">
                                         <scannedView v-if="[50].indexOf(getUserRoleId)<=-1" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Beneficiary'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Beneficiary'" />
                                   </template>
                                    <scannedView v-if="[51,50].indexOf(getUserRoleId)<=-1" :showPrevious="false" :showRecent="true"  :petition="petition" :name="'Internal'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Internal'" />
                                </vs-card>
                            </vs-tab>
                            <vs-tab :label="'History'" >
                                <vs-card class="no-card  FL-height">
                                    <scannedView v-if="(( [2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1 &&  checkProperty(petition,'petitionerId') ) || [2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))<=-1  ) && [51].indexOf(getUserRoleId)<=-1" :showPrevious="true" :showRecent="false" :petition="petition" :name="'Petitioner'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Petitioner'" />
                                    <template v-if="[2,10].indexOf(checkProperty(petition,'typeDetails', 'id'))>-1 ||  (checkProperty(petition,'beneficiaryInfo','maritalStatus' ) !=1 &&   checkProperty(petition['dependentsInfo']['spouse'], 'h4Required')==true)">
                                      <scannedView v-if="[50].indexOf(getUserRoleId)<=-1" :showPrevious="true" :showRecent="false"  :petition="petition" :name="'Beneficiary'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Beneficiary'" />
                                    </template>
                                    <scannedView v-if="[51,50].indexOf(getUserRoleId)<=-1" :showPrevious="true" :showRecent="false"  :petition="petition" :name="'Internal'" @updatepetition="updatepetition" @download_or_view="download_or_view" :currentUser="currentUser" :docUserType="'Internal'" />
                                </vs-card>
                            </vs-tab>
                        </vs-tabs>
                    </div> 
                    </vs-col>
                </vs-row>
            </template>
            
        </div>
 

    </div>

    <vs-popup class="holamundo main-popup" title="Delete form and letters" :active.sync="approveConformpopUp">
      <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p>Do you want to Delete?</p>
            
          </div>
          
        </div>
       
      </div>
      <div class="text-danger text-sm formerrors" v-show="formerrors.msg" @click="formerrors.msg=''">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="approveConformpopUp=false">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled" @click="deleteDocument()">Delete</vs-button>
      </div>
    </vs-popup>






        <div  class="custom_modal_sec documents__modal custom_modal-v2" :class="{ modalopen: downloadDocList }" >
        <div class="custom_modal_overlay"   ></div>
            <div class="custom_modal_cnt">
                <div class="modal_title">      
                    <h2> Download Documents </h2>                
                     <span class="close" @click="$emit('closeMe');downloadDocList = false"><x-icon size="1.5x"></x-icon></span>
                </div>


       <downLoadCaseDocuments @closeMe="downloadDocList=false" v-if="!loadedFromPreview && downloadDocList" @downloadfile="downloadfile" v-bind:petition="petition" v-bind:loadedFromPreview="loadedFromPreview" />
     </div>
        </div>
    
 

</div>
</template>

<script>
const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});
import scannedView from "@/views/petition/scannedCopiesView.vue"
import downLoadCaseDocuments from "@/views/petition/downLoadCaseDocuments.vue";
import FileUpload from "vue-upload-component/src";
import docType from "@/views/common/docType.vue";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Paginate from "vuejs-paginate";
import NoDataFound from "@/views/common/noData.vue";
  import draggable from "vuedraggable";
 import { XIcon } from 'vue-feather-icons'
export default {
    props: {
        loadedFromPreview:{
            type: Boolean,
            default: false,

        },
        currentRole: null,
        currentUser: null,
        petition: {
            type: Object,
            default: null
        },
        eFileTagsList:{
            type:Array,
            default:[]
        },
        workFlowDetails:{
            type: Object,
            default: null,
        }
    },
    components: {
        scannedView,
      downLoadCaseDocuments,
        NoDataFound,
        Paginate,
        FileUpload,
        docType,
        VuePerfectScrollbar,
          draggable,
          XIcon
    },
    methods: {
        reloadScannedCopies(){
            this.$refs['PetitionerSign'].getFormsAndLetters();
            this.$refs['InternalSection'].getFormsAndLetters();
        },
        dcoumentDelete(val,tab){
            this.$emit('dcoumentDelete',val,tab)
        },
        downloadfile(value, download = false, viewmode = false) {
      value.download = download;
      if(value !=null){
                value = Object.assign(value ,{ "viewmode":true})
                value['viewmode'] = true
            }
      //value.viewmode = viewmode;
      if(_.has(value ,"url" ) && !(_.has(value ,"path" ) )){
        value =Object.assign(value ,{ "path":value['url']})
      }else  if(_.has(value ,"path" ) && !(_.has(value ,"url" )) ){
        value =Object.assign(value ,{ "url":value['path']})
      }
      this.$emit('download_or_view' ,value);
        },
        download_or_view(value){
            if(value !=null){
                value = Object.assign(value ,{ "viewmode":true})
                value['viewmode'] = true
            }
            this.$emit('download_or_view' ,value);
        },
        downloadallfile() {
            this.filesDownloading =false;
            this.petitiondocumentsl =[];
            this.petitiondocumentr =[];
            this.downloadDocList = true;
            this.tempFormsAndLettersList =  _.cloneDeep(this.formsAndLettersList);
            this.splitFiles();
            this.downloadDocumentPop = true;
        },
        splitFiles(){
            
            let self =this;
            let total = Object.entries(this.petition.documents).length;
            let half = Math.round(total/2);
            this.todalDocumentsCount = 0;
            this.spouseDocumentCount = 0;
            this.totalChildDocumentCount =0;

            let docs  = _.filter(
            Object.entries(this.petitiondocuments),
            function (item) {

                if(item[1].length > 0){

                    let activeRecords = _.filter(item[1] ,(doc)=>{
                        if(doc.status && ( self.checkProperty( doc ,'path') !='' || self.checkProperty( doc ,'url') !=''  )){
                            return true;
                        }else{
                            return false;
                        }

                    })

                    if(activeRecords.length>0){
                    self.todalDocumentsCount = self.todalDocumentsCount+(activeRecords.length);
                    return true;
                    }else{
                    return false;
                    }

                }else{
                    return false;
                }
                    // return item[1].length > 0;
            }
        );

        this.petitiondocumentsl = _.cloneDeep(docs);

        if(this.checkProperty( this.petition,'dependentsInfo' ,'spouse')){

            if(this.checkProperty( this.petition['dependentsInfo'] ,'spouse','documents')){
            
            let sposeDocs = _.filter(
            Object.entries(this.petition['dependentsInfo']['spouse']['documents']),
            function (item) {

                        if(item[1] && item[1].length > 0){

                    let activeRecords = _.filter(item[1] ,(doc)=>{
                        if(doc.status && ( self.checkProperty( doc ,'path') !='' || self.checkProperty( doc ,'url') !=''  )){
                            return true;
                        }else{
                            return false;
                        }

                    })

                    if(activeRecords.length>0){
                    self.spouseDocumentCount = self.spouseDocumentCount+(activeRecords.length );
                    
                    return true;
                    }else{
                    return false;
                    }

                }else{
                    return false;
                }
            }
        );

            this.petitiondocumentr = _.cloneDeep(sposeDocs);
            

            }

        }



        //childrens
        this.childernDocuments =[];
        if(this.checkProperty( this.petition,'dependentsInfo' ,'childrens')){
        if(this.checkProperty( this.petition['dependentsInfo'] ,'childrens' ,'length')>0){

            _.forEach(this.petition['dependentsInfo']['childrens'] ,(childernDocs)=>{
            if( this.checkProperty( childernDocs ,"documents") ){

                let childDocs = _.filter(
                Object.entries(childernDocs['documents']),
                function (item) {
                    if(item[1] && item[1].length > 0){

                    let activeRecords = _.filter(item[1] ,(doc)=>{
                        if(doc.status ){
                            return true;
                        }else{
                            return false;
                        }

                    })
                    
                    if(activeRecords.length>0){

                        self.totalChildDocumentCount = self.totalChildDocumentCount+(activeRecords.length )
                        return true;
                    }else{
                    return false;
                    }

                    }else{
                        return false;
                    }
                }
                );
            
            
                
                
                self.childernDocuments.push(_.cloneDeep(childDocs))
            }

            })

        }

        }


        // this.petitiondocumentr = _.filter(
        //   Object.entries(this.petition.documents).slice(0, total),
        //   function (item) {
        //     return item[1].length > 0;
        //   }
        // );
            

            
        },
        filterActiveDocuments(){
        let self =this;
        this.petitiondocuments ={};
        _.forEach(this.petition.documents,( documents ,type)=>{
            
        let activeDocs = _.filter(documents ,(docItem)=>{
            if(docItem.status &&  ( self.checkProperty(docItem ,'path') !='' || self.checkProperty(docItem ,'url') !='' )){
                return true;
            }else{
                return false;
            }

        })
        if(activeDocs){
            this.petitiondocuments[type] = activeDocs;

        }

        })
        // Flter spouseActiveDocs
        self.spouseActiveDocs = {};
        if(this.checkProperty( this.petition,'dependentsInfo' ,'spouse')){

            if(this.checkProperty( this.petition['dependentsInfo'] ,'spouse','documents')){

            _.forEach(this.petition['dependentsInfo']['spouse']['documents'] ,( documents ,type)=>{
            
        let activeDocs = _.filter(documents ,(docItem)=>{
            if(docItem.status &&  ( self.checkProperty(docItem ,'path') !='' || self.checkProperty(docItem ,'url') !='' )){
                return true;
            }else{
                return false;
            }

        })
        if(activeDocs){
            this.spouseActiveDocs[type] = activeDocs;

        }

        })


            }
        }

        this.splitFiles();

        },
        updatepetition(){
            setTimeout(()=>{
                this.$emit("updatepetition" ,'Scanned Documents');
            } ,100);
        },
         reloadPetition() {
            setTimeout(()=>{
                this.$emit("updatepetition" ,'Scanned Documents');
            } ,100);
         },
         getFormsAndLetters(){
            this.updateLoading(true);
            this.formsAndLettersList =[];
            let finalList =[];
            let postData ={petitionId:'','page':1 ,'perpage':100000};
            postData['petitionId']= this.petition._id; 
            this.$store.dispatch("getList" ,{data:postData,path:"/petition/scanned-copies-list"}).then(response => {
                this.updateLoading(false);
                let lst = [];
                _.forEach(response.list ,(mainItem)=>{
                    mainItem = Object.assign(mainItem,{"reverse_document_versions":[] ,"mainParentId":'',showMe:true ,selectedForDownload:false});
                    if(mainItem.parentId){
                        mainItem['mainParentId'] = mainItem['parentId']
                    }else{
                            mainItem['mainParentId'] = mainItem['_id']
                    }
                        lst.push(mainItem);
                });
                let subList=[];
            //reverse_document_versions
                _.forEach(lst ,(mainItem)=>{
                    _.forEach(lst ,(subItem)=>{
                        if( mainItem.parentId && (mainItem.parentId == subItem['parentId'] ||  mainItem.parentId == subItem['_id']   ) &&  mainItem['_id'] != subItem['_id']){                            
                            subItem['showMe'] =false;
                            if(subList.indexOf(subItem['_id']<=-1)){
                                mainItem['reverse_document_versions'].push(subItem);
                                subList.push(subItem['_id']);
                            }
                        }
                    })            
                    if(mainItem.showMe){
                        finalList.push(mainItem);
                    }
                })
                this.totalpages = Math.ceil(response.totalCount / this.perpage);
                this.formsAndLettersList =  finalList;
                this.tempFormsAndLettersList = finalList;
                this.updateLoading(false);
                }).catch((err)=>{
                    this.formsAndLettersList  =[];
                    this.tempFormsAndLettersList  =[]
                    this.updateLoading(false);
                })
         },
        pageNate(pageNum) {
             this.page = pageNum;
            this.getFormsAndLetters();
        },
        openGeneratePopup(){
            this.formerrors.msg='';
            this.newFormsAndLetters =[],
            this.generatePopup =true;
        },
        pet_view_and_sign(forms, ignore){
            this.$emit('pet_view_and_sign', forms, ignore);
        }

    },
    data: () => ({
        
       tempFormsAndLettersList:[],
        itemSlength:0,
        filesDownloading:false,
        petitiondocumentsl:[],
        petitiondocumentr:[],
        downloadDocList:false,
        downloadDocumentPop:[],
        childernDocuments:[],
        todalDocumentsCount:0,
       spouseDocumentCount:0,
       totalChildDocumentCount:0,
       spouseActiveDocs:[],


        approveConformpopUp:false,
        selectedItem:null,
        generatingFiles:false,
        openItem:true,
        formLetterType:'Form',
        downloading:false, 
        downloadFiles:false,
        parentId:'',
        uploading:false,
         value:[],
        formerrors: {
        msg: ""
      },
         newFormsAndLetters:[],
        all_formTypes:[{"name":"Form" ,"id":"Form"},{"name":"Letter" ,"id":"Letter"} ],
        generatePopup:false,
        totalpages:0,
        page:1,
        perpage:25,
        formsAndLettersList:[],
        types: [],
        typeSelected: "",
        documents: [],
        documentData: [{
            type: "Forms, Letters and Others",
            documentUploaded: []
        }],
        formsData: [],
        formsAndLetterSignedUrls: [],
        documentId: "",
        version_documentUploaded: [],
        fileuploadPopup: false,
        disable_uploadBtn: false,
        selectedDoc: "",
        reversion_fileuploadPopup: false,
        disable_reversion_uploadBtn: false,
        reversionFile: null,
        fuploder: false,
        rfuploder: false,
    
    }),
    mounted() {
     
      this.getFormsAndLetters();
        //this.fetchFormsMasterData();
        
        this.filterActiveDocuments();
    },
    computed:{
        isL1Case(){
            let returnVal = false;
            if([5].indexOf(this.checkProperty(this.petition ,'typeDetails','id' )) >-1){
                returnVal =true;
            }
            return returnVal
        },
        IsSponsorLogin(){
            let returnVal =false;
            let loginUserData = this.$store.state.loginUserData;
            if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
            && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Sponsor'){
                returnVal =true
            }else{
                returnVal =false
            }
            return returnVal;   
        },
        checkIsChildh4Required(){
            let returVal = false;
            if(this.isL1Case){
                if(this.checkProperty( this.petition['dependentsInfo'] ,'childrens')){
                    _.forEach(this.petition['dependentsInfo']['childrens'],( item)=>{
                    if(item.l2Required==true){
                        returVal =true;
                    }
                    })
                }
            }else{
                if(this.checkProperty( this.petition['dependentsInfo'] ,'childrens')){
                    _.forEach(this.petition['dependentsInfo']['childrens'],( item)=>{
                    if(item.h4Required==true){
                        returVal =true;
                    }
                    })
                }
            }
            
            return returVal;
        },
        acceptedFiles(){
      let returnValue ='application/pdf , application/msword';
      /*
      if(_.has(this.newform['type'] ,"name")){
        
        if(this.newform['type']['name'] =="Form" ){
          returnValue ='application/pdf';
        }else if(this.newform['type']['name'] =="Letter" ){
          returnValue ='application/msword';
        }
       

      }
       */
      return returnValue;
      //image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document
    }
    }
};
</script>
